import React from 'react';

export type ConditionalWrapProps = {
  condition: boolean;
  wrap: (children: any) => JSX.Element;
  children: any;
};
export const ConditionalWrap = ({condition, wrap, children}: ConditionalWrapProps) =>
  condition ? wrap(children) : <>{children}</>;
